<template>
  <div class="animated fadeIn">

    <div class="modal fade show " id="modalRelatoriosVenda" tabindex="-1" role="dialog"
      aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
      data-backdrop="static" v-if="showModalProdutosRelacionados">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Produtos Relacionados</h4>
          </div>
          <div class="modal-body">
            
              
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <table class="responsive datatable_ajax display table table-striped table-hover" width="100%">
                      <thead class="thead-light">
                        <th>Produto</th>
                        <th></th>
                        <th>Percentual</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            Blusa Preta com Pedras
                          </td>
                          <td class="text-center" width="50px">
                            99%
                          </td>
                          <td class="text-center" width="100px">
                            <div class="progress progress-sm mt-2 mb-3">
                              <div class="progress-bar bg-success" :style="'width: 99%'" :aria-valuenow="99" aria-valuemin="0" aria-valuemax="99"></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Blusa Preta Regata
                          </td>
                          <td class="text-center" width="50px">
                            99%
                          </td>
                          <td class="text-center" width="100px">
                            <div class="progress progress-sm mt-2 mb-3">
                              <div class="progress-bar bg-success" :style="'width: 99%'" :aria-valuenow="99" aria-valuemin="0" aria-valuemax="99"></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Batom Matte Fashion
                          </td>
                          <td class="text-center" width="50px">
                            99%
                          </td>
                          <td class="text-center" width="100px">
                            <div class="progress progress-sm mt-2 mb-3">
                              <div class="progress-bar bg-success" :style="'width: 99%'" :aria-valuenow="99" aria-valuemin="0" aria-valuemax="99"></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Blusa Azul Escuro
                          </td>
                          <td class="text-center" width="50px">
                            50%
                          </td>
                          <td class="text-center" width="100px">
                            <div class="progress progress-sm mt-2 mb-3">
                              <div class="progress-bar bg-warning" :style="'width: 50%'" :aria-valuenow="50" aria-valuemin="0" aria-valuemax="50"></div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalProdutosRelacionados = false">Fechar</button>
          </div>
        </div>
      </div>
    </div>


    <div class="col-sm-12 col-md-12">
      <div id="dados-formulario-tab" class="card">
        <div class="card-body">
          <div id="titulo">
					  <div class="row">
						  <div class="col-sm-12 col-md-12">
							  <h4>Editar Cliente</h4>
							</div>
						</div>
					  <div class="row">
						  <div class="col-sm-12 col-md-12 pull-right">
							  <input id="botaoSalvar" class="btn btn-success" type="submit" value="Salvar" v-on:click="salvar">
                <router-link id="btnNovoCliente" class="btn btn-warning" to="/clientes">
									<span class="glyphicon glyphicon-back"></span> Fechar
								</router-link>
                <span id="imprimirLinks"> </span>
						  </div>
					  </div>
				  </div>


          <div class="row">
            <div class="col-sm-12 col-md-12">
        	    <div class="tabbable">
        				<!-- Only required for left/right tabs -->
                <ul class="nav nav-tabs">
                  <li class="nav-item active"><a href="#tabGeral" data-toggle="tab" class="nav-link active">Geral</a></li>
                  <li class="nav-item" v-on:click="buscarEnderecos"><a href="#tabEnderecosAdicionais" data-toggle="tab" class="nav-link">Endereços</a></li>
                  <li class="nav-item" v-on:click="buscarContatos"><a href="#tabContatosAdicionais" data-toggle="tab" class="nav-link">Contatos</a></li>
                  <li class="nav-item" v-on:click="buscarHistoricoFinanceiro(), buscarHistoricoCheque(), buscarClienteCreditoFinanceiro()"><a href="#tabHistoricoFinanceiro" data-toggle="tab" class="nav-link">Histórico Financeiro</a></li>
                  <li class="nav-item" v-on:click="buscarHistoricoVendas"><a href="#tabHistoricoVendas" data-toggle="tab" class="nav-link">Histórico Vendas</a></li>
                  <li class="nav-item" v-on:click="buscarHistoricoInteracoes"><a href="#tabHistoricoInteracoes" data-toggle="tab" class="nav-link">Histórico de Interações</a></li>
                  <li class="nav-item" v-on:click="buscarPerfilCliente"><a href="#tabPerfilCliente" data-toggle="tab" class="nav-link">Perfil do Cliente</a></li>
                  <li class="nav-item"><a href="#tabECommerce" data-toggle="tab" class="nav-link">e-Commerce</a></li>
                </ul>
        				<div class="tab-content">
        					<div class="tab-pane active" id="tabGeral">
        						<div class="dados_form">
        							<div class="col-sm-12 col-md-12">
        								<input type="hidden" v-model="model.id" />
        								<div class="row">
        									<div class="form-group col-sm-2 col-md-2">
        										<label>Ativo:</label><br>
        										<select class="pula form-control custom" v-model="model.ativo">
                                                <option value="false" label="Não">Não</option>
          										<option value="true" label="Sim">Sim</option>
        										</select>
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label>Tipo Cliente:</label><br>
        										<select class="pula form-control custom" v-model="model.tipoCliente">
        											<option value="J" label="Jurídico">Jurídico</option>
        											<option value="F" label="Físico">Físico</option>
        										</select>
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label>Data Aniversário:</label><br>
        										<input-data-picker class="pula data form-control" v-model="model.dataAniversario" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Conceito:</label><br>
        										<select class="pula form-control custom" v-model="model.conceitoId">
                              <option v-for="conceito in conceitos" v-bind:value="conceito.id">{{conceito.nome}}</option>
        										</select>
        									</div>
                          <div class="form-group col-sm-2 col-md-2">
        										<label>Regime Tributário:</label><br>
        										<select class="pula form-control custom" v-model="model.regimeTributario">
        											<option value="0" label="0 - Pessoa Física">0 - Pessoa Fisica</option>
        											<option value="1" label="1 - Simples Nacional">1 - Simples Nacional</option>
        											<option value="2" label="2 - Simples Nacional, excesso sublimite de receita bruta">2 - Simples Nacional, excesso sublimite de receita bruta</option>
        											<option value="3" label="3 - Regime Normal">3 - Regime Normal</option>
        										</select>
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label>Tipo Consumidor:</label><br>
        										<select class="pula form-control custom" v-model="model.tipoConsumidor">
        											<option value="0" label="0 - Normal">0 - Normal</option>
        											<option value="1" label="1 - Consumidor final">1 - Consumidor final</option>
        										</select>
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-12 col-md-12">
        										<label class="control-label">Nome Fantasia:</label><br>
                            <input name="nomeFantasia" v-validate="'required'" data-vv-delay="500" :class="{'input pula form-control': true, 'is-danger': errors.has('nomeFantasia') }" v-model="model.nomeFantasia" required="required" autofocus="autofocus" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-12 col-md-12">
        										<label class="control-label">Razao Social:</label><br>
        										<input class="pula form-control" v-model="model.nome"></input>
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-2 col-md-2">
        										<label id="label-documento" class="control-label">Documento:</label><br>
        										<input-cpf class="pula form-control" v-model="model.documento" v-if="model.tipoCliente == 'F'"/>
                            <input-cnpj class="pula form-control" v-model="model.documento" v-if="model.tipoCliente == 'J'"/>
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">RG:</label><br>
        										<input class="pula form-control" v-model="model.rg" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
                              <div class="form-group col-sm-12 col-md-12">
                                  <label class="control-label">Inscrição Estadual:</label><br>
                                  <input class="pula form-control" v-model="model.inscricaoEstadual" />
                                <input id="isentoInscricaoEstadual" v-model="isentoInscricaoEstadual" v-on:click="setIsentoInscricaoEstadual()" type="checkbox"> ISENTO</input>
                              </div>
                          </div>
                          <div class="form-group col-sm-2 col-md-2">
                              <label class="control-label">Inscrição Mun.:</label><br>
                              <input class="pula form-control" v-model="model.inscricaoMunicipal" />
                              <input id="isentoInscricaoMunicipal" v-model="isentoInscricaoMunicipal" v-on:click="setIsentoInscricaoMunicipal()" type="checkbox"> ISENTO</input>
                          </div>
        								</div>

        								<div class="row">
        									<div class="form-group col-sm-10 col-md-10">
        										<label class="control-label">Endereço:</label><br>
        										<input class="pula form-control" v-model="model.endereco" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Número:</label><br>
        										<input class="pula form-control" v-model="model.numero" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-8 col-md-8">
        										<label class="control-label">Complemento:</label><br>
        										<input class="pula form-control" v-model="model.complemento" />
        									</div>
        									<div class="form-group col-sm-4 col-md-4">
        										<label class="control-label">Bairro:</label><br>
        										<input class="pula form-control" v-model="model.bairro" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-6 col-md-6">
        										<label class="control-label">Cidade:</label><br>
      											<input type="hidden" id="cidadeId" v-model="model.cidadeId" />
                            <buscar-cidade type="search" id="cidadeNome" v-model="model.cidadeNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :on-select="setarCidade" :on-blur="verificarCidade"  />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">CEP:</label><br>
        										<input-cep id="cidadeCep" class="pula form-control" v-model="model.cep" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Estado:</label><br>
        										<input id="cidadeEstado" class="pula form-control" v-model="model.estado" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Contato:</label><br>
        										<input class="pula form-control" v-model="model.contato" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Telefone:</label><br>
        										<input-telefone class="pula form-control" v-model="model.telefone" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Celular:</label><br>
        										<input-telefone class="pula form-control" v-model="model.celular" />
        									</div>
        									<div class="form-group col-sm-1 col-md-1">
        										<label class="control-label">WhatsApp:</label><br>
        										<input id="whatsapp" class="pula" name="whatsapp" type="checkbox" v-model="model.whatsapp" />
        										<a id="abrirWhatsApp" href="#" class="btn"><img src="/static/images/whatsapp.png"></a>
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Operadora:</label><br>
        										<a href="#" class="btn" id="consultaOperadora" v-on:click="buscarOperadora(model.celular)"><img src="/static/images/buscar.png"></a>
                            <img id="logoCelularOperadora" v-bind:src="'/static/images/'+model.celularOperadora+'.png'">
                            <input type="hidden" class="pula form-control" v-model="model.celularOperadora" />
        									</div>
        									<div class="form-group col-sm-3 col-md-3">
        										<label class="control-label">E-mail:</label><br>
        										<input class="pula form-control" v-model="model.email" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-3 col-md-3">
        										<label class="control-label">Vendedor:</label><br>
                            <select class="pula form-control custom" v-model="model.vendedorId">
                              <option value="0" label="" />
                              <option v-for="vendedor in vendedores" selected v-bind:value="vendedor">{{vendedor.nome}}</option>
        										</select>
        									</div>
        									<div class="form-group col-sm-3 col-md-3">
        										<label class="control-label">Forma de Pagamento:</label><br>
                            <select class="pula form-control custom" v-model="model.formaPagamentoPadrao">
                              <option value="0" label="" />
                              <option v-for="formaPagamento in formasPagamentos" selected v-bind:value="formaPagamento.id">{{formaPagamento.nome}}</option>
        										</select>
        									</div>
        									<div class="form-group col-sm-3 col-md-3">
        										<label class="control-label">Tabela de Preço:</label><br>
        										<select class="pula form-control custom" v-model="model.produtoTabelaPrecoPadrao">
        											<option value="0" label="" />
        											<option v-for="tabelaPreco in tabelasPrecos" selected v-bind:value="tabelaPreco.id">{{tabelaPreco.nome}}</option>
        										</select>
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-4 col-md-4">
        										<label>Site:</label><br>
        										<input class="pula form-control" v-model="model.site" />
        									</div>
                          <div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">Inscrição Suf.:</label><br>
        										<input class="pula form-control" v-model="model.inscricaoSuframa" />
        									</div>
        									<div class="form-group col-sm-2 col-md-2">
        										<label class="control-label">IE ST:</label><br>
        										<input class="pula form-control" v-model="model.inscricaoEstadualSubTributario" />
        									</div>
        								</div>
        								<div class="row">
        									<div class="form-group col-sm-12 col-md-12">
        										<label>Observação:</label><br>
        										<textarea rows="3" class="pula form-control" v-model="model.observacao" />
        									</div>
        								</div>
        							</div>
        						</div>
        					</div>
        					<div class="tab-pane" id="tabEnderecosAdicionais">
        						<div class="dados_form">
        							<button id="adicionarEndereco" class="btn btn-info pull-right" type="button" v-on:click="adicionarEndereco">Adicionar Endereco</button>
        							<table id="enderecosAdicionais"
        								class="responsive datatable_ajax display table table-striped table-hover"
        								width="100%">
                        <thead class="thead-light">
        									<th>Endereço</th>
        									<th>Número</th>
        									<th>Complemento</th>
        									<th>Bairro</th>
        									<th>Cidade</th>
        									<th>Cep</th>
        									<th></th>
                        </thead>
                        <tbody>
                          <tr v-for="(endereco, i) in model.enderecos">
                            <td><input type="hidden" class="form-control" v-model="endereco.id" />
                                <input class="form-control pula" v-model="endereco.endereco" /></td>
                            <td><input class="form-control pula" v-model="endereco.numero" /></td>
                            <td><input class="form-control pula" v-model="endereco.complemento" /></td>
                            <td><input class="form-control pula" v-model="endereco.bairro" /></td>
                            <td>
                              <input type="hidden" :id="'enderecosCidadeId_'+i" v-model="endereco.cidadeId" />
                              <buscar-cidade :id="'enderecosCidadeNome_'+i"  v-model="endereco.cidadeNome" :classes="{ input: 'form-control', wrapper: 'input-wrapper'}" :on-select="setarCidadeEndereco"/>
                            </td>
                            <td><input-cep id="transportadorEnderecosCep_${loop.index}" class="form-control cep pula" v-model="endereco.cep" /></td>
                            <td>
                                <img src="/static/images/remover.png" v-on:click="removerEndereco(i)" ></img>
                            </td>
                          </tr>
        								</tbody>
        							</table>
        						</div>
        					</div>
        					<div class="tab-pane" id="tabContatosAdicionais">
        						<div class="dados_form">
        							<button id="adicionarContato" class="btn btn-info pull-right" type="button" v-on:click="adicionarContato">Adicionar Contato</button>
        							<table id="contatosAdicionais"
        								class="responsive datatable_ajax display table table-striped table-hover"
        								width="100%">
                        <thead class="thead-light">
        									<th>Nome</th>
        									<th>Telefone</th>
        									<th>Email</th>
        									<th></th>
                        </thead>
                        <tbody>
        									<tr v-for="(contato, i) in model.contatos">
                              <td><input type="hidden" class="form-control" v-model="contato.id" />
                                  <input class="form-control pula" v-model="contato.nome" />
                              </td>
                              <td><input-telefone class="form-control pula" v-model="contato.telefone" /></td>
                              <td><input class="form-control pula" v-model="contato.email" /></td>
                              <td>
                                  <img src="/static/images/remover.png" v-on:click="removerContato(i)" ></img>
                              </td>
                          </tr>
        								</tbody>
        							</table>
        						</div>
        					</div>

        					<div class="tab-pane" id="tabHistoricoFinanceiro">
        						<div class="dados_form">
                      <div class="row">
          							<div class="col-sm-2 col-md-2">
          								<label>Controla Financeiro:</label><br>
          								<select class="pula form-control custom" v-model="model.controlaFinanceiro">
          									<option value="false" label="Não">Não</option>
          									<option value="true" label="Sim">Sim</option>
          								</select>
          							</div>
          							<div class="col-sm-2 col-md-2">
          								<label>Crédito do Cliente:</label><br>
          								<input-monetario class="pula monetario form-control" v-model="model.creditoFinanceiroMovimento" />
          							</div>
          							<div class="col-sm-2 col-md-2">
          								<label>Crédito compras:</label><br>
          								<input-monetario class="pula monetario form-control" v-model="model.limiteCredito" />
          							</div>
          							<div class="col-sm-2 col-md-2">
          								<label>Crédito utilizado:</label><br>
          								<input-monetario class="pula monetario form-control" v-model="model.limiteCreditoUtilizado" readonly="readonly"/>
          							</div>
                        <div class="col-sm-2 col-md-2">
                          <label>Pontos Fidelidade:</label><br>
                          <input class="pula form-control" v-model="model.pontosFidelidade" readonly="readonly" />
                        </div>
          							<div class="col-sm-2 col-md-2">
          								<label>Bloqueado no SPC:</label><br>
          								<select class="pula form-control custom" v-model="model.bloqueadoSpc">
                            <option value="false" label="Não">Não</option>
          									<option value="true" label="Sim">Sim</option>
          								</select>
                        </div>
        							</div>
                      <br>
        							<div class="row">
        								<div class="col-sm-12 col-md-12">
        									<div id="tabelaHistoricoFinanceiro">
                            <div class="form-inline">
                              <div class="col-sm-8 col-md-8">
                                <h5>Histórico Financeiro</h5>
                              </div>
                              <div class="col-sm-4 col-md-4 text-right">
                                Exibir: 
                                <select class="pula form-control custom" v-model="exibirFinanceiro"  @change="buscarHistoricoFinanceiro()">  
                                  <option value="30" label="30 Dias">30 Dias</option>
                                  <option value="60" label="60 Dias">60 Dias</option>
                                  <option value="90" label="90 Dias">90 Dias</option>
                                  <option value="120" label="120 Dias">120 Dias</option>
                                  <option value="0" label="Tudo">Tudo</option>
                                </select>
                              </div>
                            </div>
                            <table class="responsive datatable_ajax display table table-hover" width="100%">
                              <thead class="thead-light">
                                <th>Código</th>
                                <th>Descrição</th>
              									<th>Data Lançamento</th>
              									<th>Data Vencimento</th>
              									<th>Data Pagamento</th>
                                <th>Valor</th>
                                <th>Valor Pago</th>
                                <tH></tH>
                              </thead>
                              <tbody>
              									<tr v-for="financeiro in historicoFinanceiro" :class="{ 'selecionado': selecionadoFinanceiro(financeiro) }" @click="selecionarFinanceiroItem(financeiro, $event)" >
            											<td>{{financeiro.id}}</td>
                                  <td>{{financeiro.nome}}</td>
            											<td>{{financeiro.dataLancamento}}</td>
            											<td>
                                    <template v-if="(financeiro.dataBaixa === null || financeiro.dataBaixa === '') && dataMenor(financeiro.dataVencimento, dataAtual())">
                                      <span class="text-danger"><strong>{{financeiro.dataVencimento}}</strong></span>
                                      {{diasEntreDadas(financeiro.dataVencimento, dataAtual())}} dias
                                    </template>
                                    <template v-else>
                                      {{financeiro.dataVencimento}}
                                    </template>
                                  </td>
            											<td>{{financeiro.dataBaixa}}</td>
            											<td>{{formatarMonetario(financeiro.valor)}}</td>
                                  <td>{{formatarMonetario(financeiro.valorPago)}}</td>
                                  <td width="60">
                                    <img v-tooltip="'Visualizar Financeiro'" v-on:click="visualizarFinanceiro(financeiro)" src="/static/images/visualizar.png" />
                                                                        
                                    <template v-if="financeiro.tipoMovimento === 'C' && financeiro.dataBaixa === null">
                                      <router-link v-tooltip="'Editar'" :to="{name: 'ContasReceberEditar', params: { id: financeiro.id }}" class="">
                                        <img src="/static/images/editar.png" />
                                      </router-link>
                                    </template>
                                    <template v-if="financeiro.tipoMovimento === 'D' && financeiro.dataBaixa === null">
                                      <router-link v-tooltip="'Editar'" :to="{name: 'ContasPagarEditar', params: { id: financeiro.id }}" class="">
                                        <img src="/static/images/editar.png" />
                                      </router-link>
                                    </template>
                                  </td>
            										</tr>
            									</tbody>
                              <tfoot>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <th>{{formatarMonetario(valorTotalPagarFinanceiro(this.historicoFinanceiro))}}</th>
                                <th>{{formatarMonetario(valorTotalPagoFinanceiro(this.historicoFinanceiro))}}</th>
                                <td></td>
                                
                              </tfoot>
            								</table>
        									</div>
        								</div>
        							</div>

                      <div class="row">
                        <div class="col-sm-12 col-md-12">
                          <div id="tabelaClienteCreditoFinanceiro">
                            <div class="form-inline">
                              <div class="col-sm-8 col-md-8">
                                <h5>Créditos</h5>
                              </div>
                              <div class="col-sm-4 col-md-4 text-right">
                                Exibir: 
                                <select class="pula form-control custom" v-model="exibirFinanceiroCredito" @change="buscarHistoricoCredito()">
                                  <option value="30" label="30 Dias">30 Dias</option>
                                  <option value="60" label="60 Dias">60 Dias</option>
                                  <option value="90" label="90 Dias">90 Dias</option>
                                  <option value="120" label="120 Dias">120 Dias</option>
                                  <option value="0" label="Tudo">Tudo</option>
                                </select>
                              </div>
                            </div>
                            <table class="responsive datatable_ajax display table table-striped table-hover" width="100%">
                              <thead class="thead-light">
                                <th>Código</th>
                                <th>Data</th>
                                <th>Histórico</th>
                                <th>Valor</th>
                                <th></th>
                              </thead>
                              <tbody>
                                <tr v-for="financeiro in clienteCreditoFinanceiro">
                                  <td>{{financeiro.id}}</td>
                                  <td>{{financeiro.data}}</td>
                                  <td>{{financeiro.historico}}</td>
                                  <td>{{formatarMonetario(financeiro.valor)}}</td>
                                  <td>
                                    <template v-if="financeiro.devolucaoId !== 'null'">
                                      <router-link :to="{name: 'DevolucoesVisualizar', params: { id: financeiro.devolucaoId }}" class="" >
                                        <img src="/static/images/visualizar.png" />
                                      </router-link>
                                    </template>
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th>{{formatarMonetario(valorTotalCredito(this.clienteCreditoFinanceiro))}}</th>
                                <th></th>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>

        							<div class="row">
        								<div class="col-sm-12 col-md-12">
        									<div id="tabelaHistoricoCheques">
                            <div class="form-inline">
                              <div class="col-sm-8 col-md-8">
                                <h5>Cheques</h5>
                              </div>
                              <div class="col-sm-4 col-md-4 text-right">
                                Exibir: 
                                <select class="pula form-control custom" v-model="exibirFinanceiroCheques" @change="buscarHistoricoCheque()">
                                  <option value="30" label="30 Dias">30 Dias</option>
                                  <option value="60" label="60 Dias">60 Dias</option>
                                  <option value="90" label="90 Dias">90 Dias</option>
                                  <option value="120" label="120 Dias">120 Dias</option>
                                  <option value="0" label="Tudo">Tudo</option>
                                </select>
                              </div>
                            </div>
        										<table  class="responsive datatable_ajax display table table-striped table-hover" width="100%">
                              <thead class="thead-light">
                                <th>Código</th>
        												<th>Lancamento</th>
        												<th>Emissão</th>
        												<th>Emitente</th>
        												<th>Vencimento</th>
        												<th>Pagamento</th>
                                <th>Status</th>
        												<th>Valor</th>
        												<th></th>
                              </thead>
                              <tbody>
        											  <tr v-for="cheque in historicoCheques">
        													<td width="60">{{cheque.id}}</td>
        													<td width="110">{{cheque.dataLancamento}}</td>
        													<td width="110">{{cheque.dataEmissao}}</td>
        													<td>{{cheque.emitente}}</td>
        													<td width="110">{{cheque.dataVencimento}}</td>
        													<td width="110">{{cheque.dataBaixa}}</td>
                                  <td width="110">{{cheque.status}}</td>
        													<td width="110">{{formatarMonetario(cheque.valor)}}</td>

        													<td width="60">
        														<div class="pull-right">
        															<a href="/financeiroMovimentos/editar?id=${clienteCheque.id}" data-toggle="tooltip" data-placement="top" title="Visualizar Lan�amento">
        																<span class="glyphicon glyphicon-export"></span>
        															</a>
        														</div>
        													</td>
        												</tr>
        											</tbody>
                              <tfoot>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th>{{formatarMonetario(valorTotalCheque(this.historicoCheques))}}</th>
                                <th></th>
                              </tfoot>
        										</table>
        									</div>
        								</div>
        							</div>
        						</div>
        					</div>

        					<div class="tab-pane" id="tabHistoricoVendas">
        						<div class="dados_form">
                      <div class="row">
                        <div class="col-sm-12 col-md-12">
                          <div id="tabelaHistoricoFinanceiro">
                            <div class="form-inline">
                              <div class="col-sm-8 col-md-8">                      
                                <h5>Histórico de Vendas de Produtos</h5>
                              </div>
                              <div class="col-sm-4 col-md-4 text-right">
                                Exibir: 
                                <select class="pula form-control custom" v-model="exibirFinanceiro">
                                  <option value="30" label="30 Dias">30 Dias</option>
                                  <option value="60" label="60 Dias">60 Dias</option>
                                  <option value="90" label="90 Dias">90 Dias</option>
                                  <option value="120" label="120 Dias">120 Dias</option>
                                  <option value="0" label="Tudo">Tudo</option>
                                </select>
                              </div>
                            </div>
                            <table id="tabelaHistoricoVendasProdutos"
                              class="responsive datatable_ajax display table table-striped table-hover"
                              width="100%">
                              <thead class="thead-light">
                                <th>Código</th>
                                <th>Data</th>
                                <th>Forma de Pagamento</th>
                                <th>Valor</th>
                                <th></th>
                              </thead>
                              <tbody>
                                <tr v-for="venda in vendasProdutos">
                                  <td>{{venda.id}}</td>
                                  <td>{{venda.dataVenda}}</td>
                                  <td>{{venda.formaPagamentoNome}}</td>
                                  <td>
                                    <strong>{{formatarMonetario(venda.valorTotalVenda)}}</strong>
                                  </td>
                                  <td>
                                    <img v-on:click="imprimirVendaProduto(venda.id)" src="/static/images/imprimir.png" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
        							
                      <div class="row">
                        <div class="col-sm-12 col-md-12">
                          <div id="tabelaHistoricoFinanceiro">
                            <div class="form-inline">
                              <div class="col-sm-8 col-md-8">  
                                <h5>Histórico de Vendas de Serviços</h5>
                              </div>
                              <div class="col-sm-4 col-md-4 text-right">
                                Exibir: 
                                <select class="pula form-control custom" v-model="exibirFinanceiro">
                                  <option value="30" label="30 Dias">30 Dias</option>
                                  <option value="60" label="60 Dias">60 Dias</option>
                                  <option value="90" label="90 Dias">90 Dias</option>
                                  <option value="120" label="120 Dias">120 Dias</option>
                                  <option value="0" label="Tudo">Tudo</option>
                                </select>
                              </div>
                            </div>
                            <table id="tabelaHistoricoVendasServicos"
                              class="responsive datatable_ajax display table table-striped table-hover"
                              width="100%">
                              <thead class="thead-light">
                                <th>Código</th>
                                <th>Data</th>
                                <th>Valor</th>
                                <th>Forma de Pagamento</th>
                                <th></th>
                              </thead>
                              <tbody>
              								  <tr v-for="venda in vendasServicos">
              										<td>{{venda.id}}</td>
              										<td>{{venda.dataVenda}}</td>
              										<td>
                                    <strong>{{formatarMonetario(venda.valorTotalVenda)}}</strong>
                                  </td>
              										<td>{{venda.formaPagamentoNome}}</td>
              										<td>
              												<img src="/static/images/deletar.png" />
              										</td>
              									</tr>
              								</tbody>
              							</table>
                          </div>
                        </div>
                      </div>
        						</div>
        					</div>
        					<div class="tab-pane" id="tabHistoricoInteracoes">
        						<div class="dados_form">
        							<table
        								class="responsive datatable_ajax display table table-striped table-hover"
        								width="100%">
                        <thead class="thead-light">
        									<th width="60">Código</th>
        									<th width="240">Tipo</th>
        									<th width="150">Data Lançamento</th>
        									<th>Descrição</th>
        									<th width="150">Usuário</th>
                        </thead>
                        <tbody>
        								  <tr v-for="interacao in interacoes">
        										<td>{{interacao.id}}</td>
        										<td>{{interacao.motivoInteracaoNome}}</td>
        										<td>{{interacao.dataLancamento}}</td>
        										<td>{{interacao.descricao}}</td>
        										<td>{{interacao.usuarioNome}}</td>
        									</tr>
        								</tbody>
        							</table>
        						</div>
        					</div>
        					<div class="tab-pane" id="tabPerfilCliente">
        						<div class="dados_form">
                      <div class="row">
          							<div class="col-md-12 col-sm-12">
                          <!-- <h4>Ranking do Cliente</h4> -->
                          <!-- <div class="row">
                            <div class="col-md-3">
                              <div class="cliente-ranking-posicao">
                                3º
                              </div>
                            </div>
                            <div class="col-md-3">
                              Total Vendas: <strong>R$ 1955,00</strong><br>
                              Total Descontos: <strong>R$ 5,00</strong><br>
                              Total Devoluções: <strong>R$ 0,00</strong><br><br>
                              Total Geral: <strong>R$ 1950,00</strong><br>
                              Total Custo: <strong>R$ 1368,00</strong><br><br>

                              
                              Lucro: <strong>R$ 582,00</strong>
                            </div>
                            <div class="col-md-6">
                              <table class="responsive datatable_ajax display table table-striped table-hover" width="100%">
                                <thead class="thead-light">
                                  <th>Produto</th>
                                  <th>Quantidade</th>
                                  <th>Valor Total</th>
                                </thead>
                                <tbody>
                                  <tr v-for="(produtoVendido, i) in vendasProdutosMaisVendidosPeriodoDados">
                                    <td>
                                      <div>{{produtoVendido.produtoNome}}
                                        <span class="font-weight-bold float-right">({{produtoVendido.percentual}}%)</span>
                                      </div>
                                      <div class="progress progress-sm mt-2 mb-3">
                                        <div class="progress-bar bg-info" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 0"></div>
                                        <div class="progress-bar bg-success" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 1"></div>
                                        <div class="progress-bar bg-warning" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 2"></div>
                                        <div class="progress-bar bg-danger" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 3"></div>
                                        <div class="progress-bar bg-info" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 4"></div>
                                      </div>
                                      </td>
                                      <td class="text-center" width="100px">
                                        {{produtoVendido.quantidade}}
                                      </td>
                                      <td width="150px">
                                        {{formatarMonetario(produtoVendido.valorTotal)}}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              <button class="btn btn-success btn-block" v-on:click="showModalProdutosRelacionados = true">Produtos Relacionados</button>
                              <br>
                            </div>
                          </div> -->
                          <h4>Gráfico de Vendas</h4>
                          <div class="row">
                            <div class="col-md-4">
                            </div>
                            <div class="col-md-4">
                              <select class="form-control" v-model="vendasPeriodo" @change="buscarPerfilCliente()">
                                <option value="12">12 Meses</option>
                                <option value="6">6 Meses</option>
                                <option value="1">1 Mês</option>
                              </select>
                            </div>
                            <div class="col-md-4">
                              <select class="form-control" v-model="vendasPeriodoAgrupamento" @change="buscarPerfilCliente()">
                                <option value="S">Semanal</option>
                                <option value="M">Mensal</option>
                              </select>
                            </div>
                          </div>
                          <line-chart :chart-data="perfilClienteGraficoVendas" :height="150"></line-chart>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 col-sm-12">
                          <div class="row">
                            <div class="col-md-2">
                            </div>
                            <div class="col-md-5">
                              <select class="form-control" v-model="vendasProdutosMaisVendidosPeriodo" @change="buscarPerfilCliente()">
                                <option value="12">12 Meses</option>
                                <option value="6">6 Meses</option>
                                <option value="1">1 Mês</option>
                              </select>
                            </div>
                            <div class="col-md-5">
                              <select class="form-control" v-model="vendasProdutosMaisVendidosPeriodoAgrupamento" @change="buscarPerfilCliente()">
                                <option value="V">Valor</option>
                                <option value="Q">Quantidade</option>
                              </select>
                            </div>
                          </div>

                          <table class="responsive datatable_ajax display table table-striped table-hover" width="100%">
                            <thead class="thead-light">
                              <th>Produto</th>
                              <th>Quantidade</th>
                              <th>Valor Total</th>
                            </thead>
                            <tbody>
                              <tr v-for="(produtoVendido, i) in vendasProdutosMaisVendidosPeriodoDados">
                                <td>
                                  <div>{{produtoVendido.produtoNome}}
                                    <span class="font-weight-bold float-right">({{produtoVendido.percentual}}%)</span>
                                  </div>
                                  <div class="progress progress-sm mt-2 mb-3">
                                    <div class="progress-bar bg-info" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 0"></div>
                                    <div class="progress-bar bg-success" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 1"></div>
                                    <div class="progress-bar bg-warning" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 2"></div>
                                    <div class="progress-bar bg-danger" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 3"></div>
                                    <div class="progress-bar bg-info" :style="'width: ' + produtoVendido.percentual + '%'" :aria-valuenow="produtoVendido.percentual" aria-valuemin="0" aria-valuemax="100" v-if="i === 4"></div>
                                  </div>
                                </td>
                                <td class="text-center" width="100px">
                                  {{produtoVendido.quantidade}}
                                </td>
                                <td width="150px">
                                  {{formatarMonetario(produtoVendido.valorTotal)}}
                                </td>
                              </tr>
                            </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
        					<div class="tab-pane" id="tabECommerce">
        						<div class="col-sm-12 col-md-12">
        							<div class="row">
        								<div class="form-group col-sm-3 col-md-3">
        									<label>Ativo no e-Commerce:</label><br>
        									<select class="pula form-control custom" v-model="model.ecommerceAtivo">
        										<option value="false" label="Não">Não</option>
        										<option value="true" label="Sim">Sim</option>
        									</select>
        								</div>
        								<div class="form-group col-sm-3 col-md-3">
        									<label>Código no e-Commerce:</label><br>
        									<input class="pula monetario form-control" v-model="model.ecommerceId" />
        								</div>
        							</div>
        							<div class="row">
        								<div class="form-group col-sm-12 col-md-12">
        								<label>Email e-Commerce:</label><br>
        									<input class="pula monetario form-control" v-model="model.ecommerceEmail" />
        								</div>
        							</div>
        						</div>
        					</div>
        				</div>
        			</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import LineChart from '../LineChart.js'
import Blob from 'blobjs'
export default {
  components: {
    LineChart
  },
  data () {
    return {
      model: {
        id: '0',
        erpId: '0',
        mobileId: '0',
        ativo: true,
        tipoCliente: 'F',
        tipoCadastro: '',
        dataCadastro: '',
        dataAniversario: '',
        nomeFantasia: '',
        nome: '',
        documento: '',
        rg: '',
        inscricaoEstadual: '',
        inscricaoMunicipal: '',
        inscricaoSuframa: '',
        inscricaoEstadualSubTributario: '',
        regimeTributario: '1',
        tipoConsumidor: '0',
        contribuinteIcms: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidadeId: '0',
        cidadeNome: '',
        cep: '',
        estado: '',
        contato: '',
        telefone: '',
        celular: '',
        whatsapp: '',
        celularOperadora: '',
        email: '',
        vendedorId: '0',
        vendedor: '',
        conceitoId: '1',
        conceito: {},
        formaPagamentoPadrao: '0',
        produtoTabelaPrecoPadrao: '0',
        site: '',
        observacao: '',
        enderecos: [],
        contatos: [],
        controlaFinanceiro: true,
        creditoFinanceiroMovimento: '',
        limiteCredito: '',
        limiteCreditoUtilizado: '',
        pontosFidelidade: 0,
        possuiDebito: false,
        bloqueadoSpc: false,
        ecommerceAtivo: false,
        ecommerceId: '',
        ecommerceEmail: '',
        ecommerceNome: '',
        ecommerceSobrenome: '',
        ecommerceDocumento: '',
        ecommerceTelefone: '',
        ecommerceCreditoLoja: '0',
        status: ''
      },
      isentoInscricaoEstadual: false,
      isentoInscricaoMunicipal: false,
      conceitos: [],
      formasPagamentos: [],
      tabelasPrecos: [],
      vendedores: [],
      clienteCreditoFinanceiro: [],
      historicoFinanceiro: [],
      historicoCheques: [],
      vendasProdutos: [],
      vendasServicos: [],
      interacoes: [],
      perfilClienteGraficoVendas: null,
      vendasPeriodo: '12',
      vendasPeriodoAgrupamento: 'S',
      vendasProdutosMaisVendidosPeriodo: '12',
      vendasProdutosMaisVendidosPeriodoAgrupamento: 'V',
      vendasPeriodoLabels: [],
      vendasPeriodoDados: [],
      vendasProdutosMaisVendidosPeriodoDados: [],
      exibirFinanceiro: 30,
      exibirFinanceiroCredito: 30,
      exibirFinanceiroCheques: 30,
      showModalProdutosRelacionados: false,
      selecionadosFinanceiros: [],
      selecionadosCreditos: [],
      selecionadosCheques: []
    }
  },
  created: function () {
    this.buscar()
    this.buscarConceitos()
    this.buscarFormasPagamentos()
    this.buscarTabelasPrecos()
    this.buscarVendedores()
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    buscar: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token, 'connection': 'keep-alive'}
      }
      var url = '/api/clientes/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        console.log(response.data.nomeFantasia)
        var dados = response.data
        self.model.id = dados.id
        self.model.erpId = dados.erpId
        self.model.mobileId = dados.mobileId
        self.model.ativo = dados.ativo
        self.model.tipoCliente = dados.tipoCliente
        self.model.tipoCadastro = dados.tipoCadastro
        self.model.dataCadastro = dados.dataCadastro
        self.model.dataAniversario = dados.dataAniversario
        self.model.nomeFantasia = dados.nomeFantasia
        self.model.nome = dados.nome
        self.model.documento = dados.documento
        self.model.rg = dados.rg
        self.model.inscricaoEstadual = dados.inscricaoEstadual
        if (self.model.inscricaoEstadual === 'ISENTO') {
          self.isentoInscricaoEstadual = true
        }
        self.model.inscricaoMunicipal = dados.inscricaoMunicipal
        if (self.model.inscricaoMunicipal === 'ISENTO') {
          self.isentoInscricaoMunicipal = true
        }
        self.model.inscricaoSuframa = dados.inscricaoSuframa
        self.model.inscricaoEstadualSubTributario = dados.inscricaoEstadualSubTributario
        self.model.regimeTributario = dados.regimeTributario
        self.model.tipoConsumidor = dados.tipoConsumidor
        self.model.contribuinteIcms = dados.contribuinteIcms
        self.model.endereco = dados.endereco
        self.model.numero = dados.numero
        self.model.complemento = dados.complemento
        self.model.bairro = dados.bairro
        if (dados.cidade !== null) {
          self.model.cidadeId = dados.cidade.id
          self.model.cidadeNome = dados.cidade.cidade
        }
        self.model.cep = dados.cep
        self.model.estado = dados.estado
        self.model.contato = dados.contato
        self.model.telefone = dados.telefone
        self.model.celular = dados.celular
        self.model.whatsapp = dados.whatsapp
        self.model.celularOperadora = dados.celularOperadora
        self.model.email = dados.email
        if (dados.vendedor !== null) {
          self.model.vendedorId = dados.vendedor.id
          self.model.vendedorNome = dados.vendedor.nomeFantasia
        }
        if (dados.conceito !== null) {
          self.model.conceitoId = dados.conceito.id
          self.model.conceitoNome = dados.conceito.nome
        }
        if (dados.formaPagamentoPadrao !== null) {
          self.model.formaPagamentoPadrao = dados.formaPagamentoPadrao.id
        }
        if (dados.produtoTabelaPrecoPadrao !== null) {
          self.model.produtoTabelaPrecoPadrao = dados.produtoTabelaPrecoPadrao.id
        }
        self.model.site = dados.site
        self.model.observacao = dados.observacao

        self.model.controlaFinanceiro = dados.controlaFinanceiro
        self.model.creditoFinanceiroMovimento = dados.creditoFinanceiroMovimento
        self.model.limiteCredito = dados.limiteCredito
        self.model.limiteCreditoUtilizado = dados.limiteCreditoUtilizado
        self.model.pontosFidelidade = dados.pontosFidelidade
        self.model.possuiDebito = dados.possuiDebito
        self.model.bloqueadoSpc = dados.bloqueadoSpc
        self.model.ecommerceAtivo = dados.ecommerceAtivo
        self.model.ecommerceId = dados.ecommerceId
        self.model.ecommerceEmail = dados.ecommerceEmail
        self.model.ecommerceNome = dados.ecommerceNome
        self.model.ecommerceSobrenome = dados.ecommerceSobrenome
        self.model.ecommerceDocumento = dados.ecommerceDocumento
        self.model.ecommerceTelefone = dados.ecommerceTelefone
        self.model.ecommerceCreditoLoja = dados.ecommerceCreditoLoja
        self.model.status = dados.status
        self.model.conceito = dados.conceito
      })
    },
    buscarConceitos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarConceitos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.conceitos = dados
      })
    },
    buscarFormasPagamentos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarFormasPagamentos?busca=&tipo='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.formasPagamentos = dados
      })
    },
    buscarTabelasPrecos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarProdutosTabelasPrecos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.tabelasPrecos = dados
      })
    },
    buscarVendedores: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/buscarVendedores?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.vendedores = dados
      })
    },
    buscarEnderecos: function () {
      var self = this
      if (self.model.enderecos.length === 0) {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        var url = '/api/buscarClientesEnderecos/' + this.$route.params.id
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.model.enderecos = dados
        })
      }
    },
    buscarContatos: function () {
      var self = this
      if (self.model.contatos.length === 0) {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        var url = '/api/buscarClientesContatos/' + this.$route.params.id
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.model.contatos = dados
        })
      }
    },
    buscarHistoricoCredito: function () {
      var self = this
      if (self.clienteCreditoFinanceiro.length === 0) {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        var url = '/api/buscarClientesCreditos?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiroCredito
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.clienteCreditoFinanceiro = dados
        })
      }
    },
    selecionarCreditoItem: function (item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosCreditos.includes(item)) {
          let p = this.selecionadosCreditos.indexOf(item)
          this.selecionadosCreditos.splice(p, 1)
        } else {
          this.selecionadosCreditos.push(item)
        }
      } else {
        this.selecionadosCreditos = []
        this.selecionadosCreditos.push(item)
      }
    },
    selecionadoCredito: function (item) {
      return this.selecionadosCreditos.includes(item)
    },
    buscarHistoricoFinanceiro: function () {
      var self = this
      // if (self.historicoFinanceiro.length === 0) {
      let config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      let url = '/api/clienteHistoricoFinanceiro?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiro
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.historicoFinanceiro = dados
      })
    },
    selecionarFinanceiroItem: function (item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosFinanceiros.includes(item)) {
          let p = this.selecionadosFinanceiros.indexOf(item)
          this.selecionadosFinanceiros.splice(p, 1)
        } else {
          this.selecionadosFinanceiros.push(item)
        }
      } else {
        this.selecionadosFinanceiros = []
        this.selecionadosFinanceiros.push(item)
      }
    },
    selecionadoFinanceiro: function (item) {
      return this.selecionadosFinanceiros.includes(item)
    },
    buscarHistoricoCheque: function () {
      var self = this
      let config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      let url = '/api/clienteHistoricoCheque?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiroCheques
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.historicoCheques = dados
      })
    },
    selecionarChequeItem: function (item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosCheques.includes(item)) {
          let p = this.selecionadosCheques.indexOf(item)
          this.selecionadosCheques.splice(p, 1)
        } else {
          this.selecionadosCheques.push(item)
        }
      } else {
        this.selecionadosCheques = []
        this.selecionadosCheques.push(item)
      }
    },
    selecionadoCheque: function (item) {
      return this.selecionadosCheques.includes(item)
    },
    valorTotalPagarFinanceiro: function (financeiroMovimento) {
      if (this.selecionadosFinanceiros.length > 1) {
        return this.selecionadosFinanceiros.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valor
          }
          return valorTotalPagar
        }, 0)
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valor
          }
          return valorTotalPagar
        }, 0)
      }
    },
    valorTotalPagoFinanceiro: function (financeiroMovimento) {
      if (this.selecionadosFinanceiros.length > 1) {
        return this.selecionadosFinanceiros.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valorPago
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valorPago
          }
          return valorTotalPagar
        }, 0)
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valorPago
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valorPago
          }
          return valorTotalPagar
        }, 0)
      }
    },
    valorTotalCredito: function (financeiroMovimento) {
      if (this.selecionadosCreditos.length > 1) {
        return this.selecionadosCreditos.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          return valorTotalPagar
        }, 0)
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          return valorTotalPagar
        }, 0)
      }
    },
    valorTotalCheque: function (financeiroMovimento) {
      if (this.selecionadosCheques.length > 1) {
        return this.selecionadosCheques.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          return valorTotalPagar
        }, 0)
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor
          return valorTotalPagar
        }, 0)
      }
    },
    buscarHistoricoVendas: function () {
      var self = this
      if (self.vendasProdutos.length === 0) {
        var config = {
          headers: {'Authorization': 'Bearer ' + this.$store.state.token}
        }
        var url = '/api/clientesHistoricoVendasProdutos/' + this.$route.params.id
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.vendasProdutos = dados
        })
      }
      if (self.vendasServicos.length === 0) {
        url = '/api/clientesHistoricoVendasServicos/' + this.$route.params.id
        axios.get(url, config)
        .then(function (response) {
          console.log(response.data)
          var dados = response.data
          self.vendasServicos = dados
        })
      }
    },
    buscarHistoricoInteracoes: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/clientesHistoricoInteracoes/' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.interacoes = dados
      })
    },
    buscarOperadora: function (numero) {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/consutarOperadora?celular=' + numero
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.model.celularOperadora = response.data
      })
    },
    setIsentoInscricaoEstadual: function () {
      if (this.isentoInscricaoEstadual === false) {
        this.model.inscricaoEstadual = 'ISENTO'
      } else {
        this.model.inscricaoEstadual = ''
      }
    },
    setIsentoInscricaoMunicipal: function () {
      if (this.isentoInscricaoMunicipal === false) {
        this.model.inscricaoMunicipal = 'ISENTO'
      } else {
        this.model.inscricaoMunicipal = ''
      }
    },
    setarCidade: function (cidade) {
      this.model.cidadeId = cidade.id
      this.model.cidadeNome = cidade.cidade
      this.model.cep = cidade.cep
      this.model.estado = cidade.estado
      $(this.$el).find('#cidadeNome').val(cidade.cidade)
      $(this.$el).find('#cidadeCep').val(cidade.cep)
      $(this.$el).find('#cidadeEstado').val(cidade.estado)
    },
    verificarCidade: function () {
      if ($(this.$el).find('#cidadeId').val() === '0') {
        this.model.cidadeId = 0
        this.model.cidadeNome = ''
        this.model.cep = ''
        this.model.estado = ''
        $(this.$el).find('#cidadeId').val(0)
        $(this.$el).find('#cidadeNome').val('')
        $(this.$el).find('#cidadeCep').val('')
        $(this.$el).find('#cidadeEstado').val('')
      }
      if ($(this.$el).find('#cidadeNome').val() === '') {
        this.model.cidadeId = 0
        this.model.cidadeNome = ''
        this.model.cep = ''
        this.model.estado = ''
        $(this.$el).find('#cidadeId').val(0)
        $(this.$el).find('#cidadeNome').val('')
        $(this.$el).find('#cidadeCep').val('')
        $(this.$el).find('#cidadeEstado').val('')
      }
    },
    setarCidadeEndereco: function (cidade, i) {
      console.log('Item: ' + i)
      this.model.enderecos[i].cidadeId = cidade.id
      this.model.enderecos[i].cidadeNome = cidade.cidade
      this.model.enderecos[i].cep = cidade.cep
      this.model.enderecos[i].estado = cidade.estado
      $(this.$el).find('#enderecosCidadeNome_' + i).val(cidade.cidade)
      $(this.$el).find('#enderecosCidadeCep_' + i).val(cidade.cep)
      $(this.$el).find('#enderecosCidadeEstado_' + i).val(cidade.estado)
    },
    adicionarEndereco: function () {
      var self = this
      self.model.enderecos.push({
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        pontoReferencia: '',
        cidadeId: '0',
        cidade: '',
        cep: '',
        tipoEnderecoId: '0'
      })
    },
    removerEndereco: function (i) {
      var self = this
      self.model.enderecos.splice(i, 1)
    },
    adicionarContato: function () {
      var self = this
      self.model.contatos.push({
        nome: '',
        telefone: '',
        email: ''
      })
    },
    removerContato: function (i) {
      var self = this
      self.model.contatos.splice(i, 1)
    },
    buscarPerfilCliente: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/dashboard/vendasPeriodo?periodo=' + this.vendasPeriodo + '&agrupamento=' + this.vendasPeriodoAgrupamento + '&clienteId=' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        let periodos = []
        for (let i = 0; i < response.data.length; i++) {
          periodos.push(response.data[i].periodo + '/' + response.data[i].ano)
        }
        let valores = []
        for (let i = 0; i < response.data.length; i++) {
          valores.push(response.data[i].valorTotalVenda)
        }
        self.perfilClienteGraficoVendas = {
          labels: periodos,
          datasets: [
            {
              label: 'Vendas',
              backgroundColor: '#79c447',
              data: valores
            }
          ]
        }
      })
      url = '/api/dashboard/vendasProdutosMaisVendidosPeriodo?periodo=' + this.vendasProdutosMaisVendidosPeriodo + '&agrupamento=' + this.vendasProdutosMaisVendidosPeriodoAgrupamento + '&clienteId=' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.vendasProdutosMaisVendidosPeriodoDados = response.data
      })
    },
    imprimirVendaProduto: function (vendaProdutoId) {
      // Imprimir
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      }
      var url = '/api/vendas/imprimirVenda?id=' + vendaProdutoId + '&exibirCliente=1&exibirMarca=1&exibirPreco=1&exibirPrecoPadrao=0&exibirPromissoria=0'
      axios.get(url, config)
      .then(function (response) {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        // link.setAttribute('filename', 'file.pdf')
        link.setAttribute('target', '_blank')
        document.getElementById('imprimirLinks').appendChild(link)
        link.click()
      })
    },
    visualizarFinanceiro: function (movimento) {
      // this.$router.replace('/financeiroMovimentoVisualizar/' + movimento.id)
      // let routeData = this.$router.resolve({name: 'FinanceiroMovimentoVisualizar', query: {data: movimento.id}})
      window.open('/financeiroMovimentoVisualizar/' + movimento.id, '_blank')
    },
    salvar: function () {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(JSON.stringify(self.model))
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.$store.state.token
            }
          }
          var url = '/api/clientes/salvar'
          axios.post(url, JSON.stringify(self.model), config)
          .then(function (response) {
            console.log(response)
            if (response.data === 'OK') {
              self.$toastr('success', 'Cliente gravado com sucesso.', 'Atenção')
              self.$router.replace('/clientes')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
        } else {
          this.$toastr('error', 'Complete os campos destacados.', 'Atenção')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/clientes/ClientesEditar.vue